import React from 'react';
import { Typography, useMediaQuery } from 'fronton-react';
import { TState } from 'pages/dimensions/store/dimensions';

const DATA_TEST_ID = 'configuration-additional-info';

const Info = ({ title }: { title: string }) => {
  const isMobile = useMediaQuery({
    maxWidth: 767,
  });

  if (isMobile) {
    return (
      <Typography size="caption" variant="minor" color="text-primary" data-testid={DATA_TEST_ID}>
        {title}
      </Typography>
    );
  }

  return (
    <Typography size="body_long" variant="s" color="text-primary" data-testid={DATA_TEST_ID}>
      {title}
    </Typography>
  );
};

export const AdditionalInfo = ({ surface, inputParameters }: Partial<TState>) => {
  if (surface?.FLOOR?.typeInstallation) {
    return <Info title={`Направление укладки: ${surface?.FLOOR?.typeInstallation}`} />;
  }

  if (inputParameters?.layerThickness) {
    return <Info title={`Толщина слоя: ${inputParameters?.layerThickness} мм`} />;
  }

  if (inputParameters?.height) {
    return <Info title={`Высота потолка: ${inputParameters?.height} м`} />;
  }

  return null;
};
